import { gql } from "@apollo/client";
import { Def_MutationResponse } from "./userCalls";

export const WORKER_LIST = gql`
  query WorkerList($domain: String!) {
    company {
      workerList(domain: $domain) {
        user_group_id
        name
        description
        fk_company
        user_id
        username
        attention_email_systems
      }
    }
  }
`

export interface UsersWithGroups {
  user_group_id: number
  name: string
  description: string
  fk_company: number
  user_id: number
  username: string
  attention_email_systems?: number[]
}


export interface WorkerListResponse {
  company: {
    workerList: UsersWithGroups[]
  }
}

export const ADD_DOMAIN_WORKER = gql`
  mutation AddDomainWorker($username: String!, $domain: String!) {
    user {
      addDomainWorker(username: $username, domain: $domain) {
        code
        success
        message
      }
    }
  }
`
export interface AddDomainWorkerResponse {
  user: {
    addDomainWorker: Def_MutationResponse
  }
}

export const REMOVE_DOMAIN_USER = gql`
  mutation RemoveDomainUser($username: String!, $domain: String!) {
    user {
      removeDomainUser(username: $username, domain: $domain) {
        code
        success
        message
      }
    }
  }
`
export interface RemoveDomainUserResponse {
  user: {
    removeDomainUser: Def_MutationResponse
  }
}


export const REMOVE_GROUP_FROM_USER = gql`
mutation RemoveGroupUser($domain: String!, $username: String!, $usergroupid: Int!) {
  user {
    removeGroupUser(domain: $domain, username: $username, usergroupid: $usergroupid) {
      code
      success
      message
    }
  }
}
`
export interface RemoveGroupFromUserResponse {
  user: {
    removeGroupUser: Def_MutationResponse
  }
}

export const SET_USER_ATTENTION_EMAIL_SYSTEMS = gql`
  mutation SetUserAttentionEmailSystems($domain: String!, $username: String!, $systemIds: [Int!]!) {
    company {
      setUserAttentionEmailSystems(domain: $domain, username: $username, system_ids: $systemIds) {
        code
        success
        message
      }
    }
  }
`

export interface SetUserAttentionEmailSystemsResponse {
  company: {
    setUserAttentionEmailSystems: Def_MutationResponse
  }
}

